import {Icon} from './Icon';
import {useLocation} from 'react-router';
import {Link} from './ScopedLink';
import {selectedBuilding} from './building-scope';
import {operatingReturn} from './operating-queue';
import {workQueueReturnContext} from './work-queue-navigation';
export function WorkQueueReturnLink({fallback=false,fallbackLabel='Back to all works'}:{fallback?:boolean;fallbackLabel?:string}){
 const location=useLocation(),context=workQueueReturnContext(location.state,selectedBuilding(location.pathname,location.search));
 const operating=operatingReturn(location.state,selectedBuilding(location.pathname,location.search));
 if(operating)return <Link className="back-link" to={operating.to} state={{operatingSearch:operating.search,operatingFocusKey:operating.focusKey}}><Icon name="arrow-left"/>Return to operating queue</Link>;
 if(!context&&!fallback)return null;
 return <Link className="back-link" to={context?.to??'/work/all'} state={context?{workSearch:context.search,workFocusKey:context.focusKey}:undefined}><Icon name="arrow-left"/>{context?'Return to work queue':fallbackLabel.replace(/^←\s*/, '')}</Link>;
}
